export default "__VITE_ASSET__BizYnv6l__"